export default "__VITE_ASSET__CeMD0NKg__"